export const getImovel = (state) => state.imovel;
